import React, { useContext, useState } from 'react';
import Input from '../Shared/Input';
import "../Styles/forgetpassword.css";
import NextButton from '../Shared/NextButton';
import { Typography } from '@mui/material';
import {LanguageContext} from '../language/LanguageContext';
import consts from '../Utilities/appConsts.json';
import ModalAlert from '../Shared/ModalAlert';

interface ForgetPasswordLinkProps {
  setMail: (value: string) => void;
  mail: string;
  sendLink: (mail: string) => void;
  isShowHelperText: boolean;
  setIsShowHelperText: React.Dispatch<React.SetStateAction<boolean>>;
  setIsAddActiveModal: React.Dispatch<React.SetStateAction<boolean>>;
  isAddActiveModal: boolean;
}

const ForgetPasswordLink: React.FC<ForgetPasswordLinkProps> = ({ setMail, mail, sendLink, isShowHelperText,setIsShowHelperText,setIsAddActiveModal,isAddActiveModal }) => {
  const { getTranslation } = useContext(LanguageContext);
  return (
    <>
                <ModalAlert
                open={isAddActiveModal}
                onClose={(isApproved: boolean) => {
                    setIsAddActiveModal(false);
                }}
                title={"אופס"}
                content={"החשבון הזה נסגר לבקשתך.כדי להתחבר צריך להקליד כתובת מייל אחרת"}
                textTrue={"הבנתי"}
                textFalse={""}
            />
      <Typography className='typography-sm-fp-l'>
        {getTranslation(consts.DESCRIBE_FORGET_PASSWORD)}</Typography>
      <Input
        label={getTranslation(consts.EMAIL)}
        className="textField mb-input-login"
        characterLimit={50}
        name={"email"}
        isRequired={false}
        variant="standard"
        showHelperText={isShowHelperText ? true : false}
        setShowHelperText={setIsShowHelperText}
        helperText={isShowHelperText && "אנחנו לא מכירים כתובת מייל כזו"}
        endAdornment={false}
        value={mail ? mail : ""}
        setValue={(name: any, value: any, setShowHelperText:any)  => {
          setMail(value);
          setShowHelperText && setIsShowHelperText(false);
      }}
      />
      <NextButton  handleOnClick={() => sendLink(mail)} class='btn-fp-mail btn-fp-mail-mt' text={getTranslation(consts.SEND_ME_LINK)} />
    </>
  );
};

export default ForgetPasswordLink;
